import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateAccountComponent } from './create-account.component';
import { AuthGuard } from './guards/auth-guard/auth.guard';
import { LeavePageGuard } from './guards/leave-page/leave-page.guard';
import { LogInComponent } from './log-in/log-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { VerifyAccountComponent } from './verify-account/verify-account.component';
import { AuthResolver } from '../resolvers/auth-resolver/auth.resolver';
import { ReferralGuardGuard } from './guards/referral-guard.guard';

const routes: Routes = [
  {
    path: '',
    component: CreateAccountComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'create-account',
        redirectTo: 'signup',
        pathMatch: 'full'
      },
      {
        path: 'verify-account',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'signup',
        component: SignUpComponent,
        data: { title: 'Truein Sign Up | User Dashboard' },
        canActivate: [AuthGuard],
        resolve: {
          sessionData: AuthResolver
        }
      },
      {
        path: 'login',
        component: LogInComponent,
        data: { title: 'Truein Login | User Dashboard' },
        resolve: {
          sessionData: AuthResolver
        }
      },
      {
        path: 'reset-password',
        component: LogInComponent,
        data: { title: 'Truein Reset Password | User Dashboard' },
      },
      {
        path: 'setup',
        component: SignUpComponent,
        data: { title: 'Truein Setup | User Dashboard' },
        canActivate: [ReferralGuardGuard],
        resolve: {
          sessionData: AuthResolver
        }
      },
      {
        path: '**',
        redirectTo: 'login'
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateAccountRoutingModule { }
